export default __webpack_public_path__ + "static/media/logo-PMH.2a5c69bf.svg";